/* eslint-disable */

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['exports', 'echarts'], factory);
    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        // CommonJS
        factory(exports, require('echarts'));
    } else {
        // Browser globals
        factory({}, root.echarts);
    }
}(this, function (exports, echarts) {
    const log = function (msg) {
        if (typeof console !== 'undefined') {
            console && console.error && console.error(msg);
        }
    };
    if (!echarts) {
        log('ECharts is not Loaded');
        return;
    }
    echarts.registerTheme('lb-dark', {
        "color": [
            "#e21e27",
            "#eb6823",
            "#f8be15",
            "#acce37",
            "#9cd2ff",
            "#00b3ea",
            "#f37d7f",
            "#fcbe7f",
            "#faf183",
            "#c2db79",
            "#98d8e5"
        ],
        "backgroundColor": "#222222",
        "textStyle": {},
        "title": {
            "textStyle": {
                "color": "#c4c4c4"
            },
            "subtextStyle": {
                "color": "#c4c4c4"
            }
        },
        "line": {
            "itemStyle": {
                "borderWidth": 1
            },
            "lineStyle": {
                "width": "2"
            },
            "symbolSize": "6",
            "symbol": "circle",
            "smooth": false
        },
        "radar": {
            "itemStyle": {
                "borderWidth": 1
            },
            "lineStyle": {
                "width": "2"
            },
            "symbolSize": "6",
            "symbol": "circle",
            "smooth": false
        },
        "bar": {
            "itemStyle": {
                "barBorderWidth": 0,
                "barBorderColor": "#c4c4c4"
            }
        },
        "pie": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#c4c4c4"
            }
        },
        "scatter": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#c4c4c4"
            }
        },
        "boxplot": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#c4c4c4"
            }
        },
        "parallel": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#c4c4c4"
            }
        },
        "sankey": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#c4c4c4"
            }
        },
        "funnel": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#c4c4c4"
            }
        },
        "gauge": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#c4c4c4"
            }
        },
        "candlestick": {
            "itemStyle": {
                "color": "#fd1050",
                "color0": "#0cf49b",
                "borderColor": "#fd1050",
                "borderColor0": "#0cf49b",
                "borderWidth": 1
            }
        },
        "graph": {
            "itemStyle": {
                "borderWidth": 0,
                "borderColor": "#c4c4c4"
            },
            "lineStyle": {
                "width": 1,
                "color": "#aaaaaa"
            },
            "symbolSize": "6",
            "symbol": "circle",
            "smooth": false,
            "color": [
                "#e21e27",
                "#eb6823",
                "#f8be15",
                "#acce37",
                "#9cd2ff",
                "#00b3ea",
                "#f37d7f",
                "#fcbe7f",
                "#faf183",
                "#c2db79",
                "#98d8e5"
            ],
            "label": {
                "color": "#c4c4c4"
            }
        },
        "map": {
            "itemStyle": {
                "areaColor": "#eee",
                "borderColor": "#444",
                "borderWidth": 0.5
            },
            "label": {
                "color": "#000"
            },
            "emphasis": {
                "itemStyle": {
                    "areaColor": "rgba(255,215,0,0.8)",
                    "borderColor": "#444",
                    "borderWidth": 1
                },
                "label": {
                    "color": "rgb(100,0,0)"
                }
            }
        },
        "geo": {
            "itemStyle": {
                "areaColor": "#eee",
                "borderColor": "#444",
                "borderWidth": 0.5
            },
            "label": {
                "color": "#000"
            },
            "emphasis": {
                "itemStyle": {
                    "areaColor": "rgba(255,215,0,0.8)",
                    "borderColor": "#444",
                    "borderWidth": 1
                },
                "label": {
                    "color": "rgb(100,0,0)"
                }
            }
        },
        "categoryAxis": {
            "axisLine": {
                "show": true,
                "lineStyle": {
                    "color": "#444444"
                }
            },
            "axisTick": {
                "show": true,
                "lineStyle": {
                    "color": "#444444"
                }
            },
            "axisLabel": {
                "show": true,
                "color": "#c4c4c4"
            },
            "splitLine": {
                "show": true,
                "lineStyle": {
                    "color": [
                        "#444444"
                    ]
                }
            },
            "splitArea": {
                "show": false,
                "areaStyle": {
                    "color": [
                        "#eeeeee"
                    ]
                }
            }
        },
        "valueAxis": {
            "axisLine": {
                "show": true,
                "lineStyle": {
                    "color": "#444444"
                }
            },
            "axisTick": {
                "show": true,
                "lineStyle": {
                    "color": "#444444"
                }
            },
            "axisLabel": {
                "show": true,
                "color": "#c4c4c4"
            },
            "splitLine": {
                "show": true,
                "lineStyle": {
                    "color": [
                        "#444444"
                    ]
                }
            },
            "splitArea": {
                "show": false,
                "areaStyle": {
                    "color": [
                        "#eeeeee"
                    ]
                }
            }
        },
        "logAxis": {
            "axisLine": {
                "show": true,
                "lineStyle": {
                    "color": "#444444"
                }
            },
            "axisTick": {
                "show": true,
                "lineStyle": {
                    "color": "#444444"
                }
            },
            "axisLabel": {
                "show": true,
                "color": "#c4c4c4"
            },
            "splitLine": {
                "show": true,
                "lineStyle": {
                    "color": [
                        "#444444"
                    ]
                }
            },
            "splitArea": {
                "show": false,
                "areaStyle": {
                    "color": [
                        "#eeeeee"
                    ]
                }
            }
        },
        "timeAxis": {
            "axisLine": {
                "show": true,
                "lineStyle": {
                    "color": "#444444"
                }
            },
            "axisTick": {
                "show": true,
                "lineStyle": {
                    "color": "#444444"
                }
            },
            "axisLabel": {
                "show": true,
                "color": "#c4c4c4"
            },
            "splitLine": {
                "show": true,
                "lineStyle": {
                    "color": [
                        "#444444"
                    ]
                }
            },
            "splitArea": {
                "show": false,
                "areaStyle": {
                    "color": [
                        "#eeeeee"
                    ]
                }
            }
        },
        "toolbox": {
            "iconStyle": {
                "borderColor": "#c4c4c4"
            },
            "emphasis": {
                "iconStyle": {
                    "borderColor": "#666666"
                }
            }
        },
        "legend": {
            "textStyle": {
                "color": "#c4c4c4"
            }
        },
        "tooltip": {
            "axisPointer": {
                "lineStyle": {
                    "color": "#444444",
                    "width": "1"
                },
                "crossStyle": {
                    "color": "#444444",
                    "width": "1"
                }
            }
        },
        "timeline": {
            "lineStyle": {
                "color": "#eeeeee",
                "width": 1
            },
            "itemStyle": {
                "color": "#dd6b66",
                "borderWidth": 1
            },
            "controlStyle": {
                "color": "#eeeeee",
                "borderColor": "#eeeeee",
                "borderWidth": 0.5
            },
            "checkpointStyle": {
                "color": "#e43c59",
                "borderColor": "#c23531"
            },
            "label": {
                "color": "#eeeeee"
            },
            "emphasis": {
                "itemStyle": {
                    "color": "#a9334c"
                },
                "controlStyle": {
                    "color": "#eeeeee",
                    "borderColor": "#eeeeee",
                    "borderWidth": 0.5
                },
                "label": {
                    "color": "#eeeeee"
                }
            }
        },
        "visualMap": {
            "color": [
                "#4483bf",
                "#d88273",
                "#f6efa6"
            ]
        },
        "dataZoom": {
            "backgroundColor": "rgba(47,69,84,0)",
            "dataBackgroundColor": "rgba(255,255,255,0.3)",
            "fillerColor": "rgba(167,183,204,0.4)",
            "handleColor": "#a7b7cc",
            "handleSize": "100%",
            "textStyle": {
                "color": "#eeeeee"
            }
        },
        "markPoint": {
            "label": {
                "color": "#c4c4c4"
            },
            "emphasis": {
                "label": {
                    "color": "#c4c4c4"
                }
            }
        }
    });
}));
